exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.groups-wrapper {\n  background-color: #f0f0f0;\n  border-radius: 4px;\n}\n@keyframes blink {\n0% {\n    background-color: #fcf7df;\n}\n50% {\n    background-color: transparent;\n}\n100% {\n    background-color: #fcf7df;\n}\n}\n.highlight {\n  animation: blink 0.9s ease-in-out 3;\n}\n", ""]);

// exports
